const extractPaths = (pagePath: string, hubsSlugs: string[]) => {
  const splittedPath = pagePath.split('/');
  if (hubsSlugs?.includes(splittedPath[0])) {
    return splittedPath[0];
  }
  return pagePath || 'home';
};

export default extractPaths;
